import postApi from "../api/postApi";
import * as url from "../api/url";

export const postMachinesList = (payload, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(url.GET_MACHINES_LIST, payload, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const GetPagedAssets = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(url.GET_PAGE_ASSET_LIST, payload, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const GetPagedWatchlistAssets = (payload, header, instance, accounts) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(url.GET_WATCH_LIST, payload, header, instance, accounts)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};
